import './sass/prices2023.scss';

(function ($) {
    // var current = 1;
    display2($('#rotmenu2 li:first'));

    $('#rotmenu2 li').on('click', function (e) {
        $('table.table-prices').hide();
        display2($(this));
        e.preventDefault();
    });

    function display2(elem) {
        var $this = elem;
        //var repeat = false;
        $('#rotmenu2 li a').removeClass('active');
        $this.find('a').addClass('active');

        // if (current == parseInt($this.index() + 1))
        //     repeat = true;
        // if (!repeat)
        // $this.parent().find('li:nth-child(' + current + ') a').stop(true, true).animate({ 'opacity': '0.7' }, 700);

        // current = parseInt($this.index() + 1);
        var elem = $('a', $this);
        // elem.stop(true, true).animate({ 'opacity': '1.0' }, 300);
        var info_elem = elem.next();

        $('#rot1a .heading').animate({ 'opacity': '0' }, 500, 'easeOutCirc', function () {
            $('h1', $(this)).html(info_elem.find('.info_heading').html());
            $('.title-icon', $(this)).html(info_elem.find('.info_image').html());
            $(this).animate({ 'opacity': '1' }, 400, 'easeInOutQuad');
        });

        $('#rot1a .description').animate({ 'bottom': '-700px' }, 1000, 'easeOutCirc', function () {
            $('p', $(this)).html(info_elem.find('.info_description').html());
            $('#rot1a .description table.table-shekel').show();

            // var h_menu2 = $('#contentPrice2 .rotator2 ul').height() + $(this).height() + $('#rot1a .heading').height() + 16;
            // $('.rotator2').animate({ 'height': h_menu2 }, 1000, 'easeOutCirc');
            $(this).animate({ 'bottom': '0px' }, 1000, 'easeInOutQuad');

            $('#rot1a .currency-button').on('click', function (e) {
                $('table.table-prices').hide();
                var id = $(this).data('box');
                $('table#' + id).show();
            });
        })

    }
})(jQuery);